import googleDriveIcon from './img/google-drive.svg';
import oneDriveIcon from './img/one-drive.svg';
import sharePointIcon from './img/sharepoint.svg';

export type SmartFolderRovoConnectorProvider = 'google-drive' | 'sharepoint' | 'onedrive';

export type SmartFolderRovoConnectorProviderConfig = {
	provider: SmartFolderRovoConnectorProvider;
	displayName: string;
	connectorNames: readonly string[];
	iconSrc: string;
};

export const SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS: {
	readonly 'google-drive': {
		readonly provider: 'google-drive';
		readonly displayName: 'Google Drive';
		readonly connectorNames: readonly [
			'google-drive-connector',
			'smartlinks-connector-gdrive',
			'smartlinks-connector-gdrive-rsl',
			'lite-connector-gdrive',
		];
		readonly iconSrc: any;
	};
	readonly sharepoint: {
		readonly provider: 'sharepoint';
		readonly displayName: 'SharePoint';
		readonly connectorNames: readonly [
			'sharepoint-connector',
			'smartlinks-connector-sharepoint',
			'ai-3p-connector:sharepoint-domain',
		];
		readonly iconSrc: any;
	};
	readonly onedrive: {
		readonly provider: 'onedrive';
		readonly displayName: 'OneDrive';
		readonly connectorNames: readonly ['smartlinks-connector-onedrive', 'onedrive-connector'];
		readonly iconSrc: any;
	};
} = {
	'google-drive': {
		provider: 'google-drive',
		displayName: 'Google Drive',
		connectorNames: [
			'google-drive-connector',
			'smartlinks-connector-gdrive',
			'smartlinks-connector-gdrive-rsl',
			'lite-connector-gdrive',
		],
		iconSrc: googleDriveIcon,
	},
	sharepoint: {
		provider: 'sharepoint',
		displayName: 'SharePoint',
		connectorNames: [
			'sharepoint-connector',
			'smartlinks-connector-sharepoint',
			'ai-3p-connector:sharepoint-domain',
		],
		iconSrc: sharePointIcon,
	},
	onedrive: {
		provider: 'onedrive',
		displayName: 'OneDrive',
		connectorNames: ['smartlinks-connector-onedrive', 'onedrive-connector'],
		iconSrc: oneDriveIcon,
	},
} as const satisfies Record<
	SmartFolderRovoConnectorProvider,
	SmartFolderRovoConnectorProviderConfig
>;
